import {getInstanceId} from '@wix/music-shared/dist/src/utils/wix-utils';

export function isBlacklisted() {
  return getInstanceId() === '13f6a157-4a25-d5c9-c095-e4d531d5c8e2';
}
